import { render, staticRenderFns } from "./planBearbeiten.vue?vue&type=template&id=3469a5f7"
import script from "./planBearbeiten.vue?vue&type=script&lang=js"
export * from "./planBearbeiten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports